import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface Contact {
  name: string,
  phone: string,
  email: string
}

interface ICustomerAdd {
  customerName: string,
  categories: string,
  accountName: string,
  password: string,
  logo: string,
  address?: string,
  province?: string,
  district?: string,
  country?: string,
  contact?: Contact[] | [],
  arrayContact: number[]
}

export interface CounterState {
  value: number,
  isShowAdd: boolean,
  customerAdd: ICustomerAdd
}

const initialState: CounterState = {
  value: 0,
  isShowAdd: false,
  customerAdd: {
    customerName: '',
    categories: '',
    accountName: '',
    password: '',
    logo: '',
    address: '',
    province: '',
    district: '',
    country: '',
    contact: [],
    arrayContact: Array.from({ length: 1 }, (_, i) => i)
  }
}

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1
    },
    decrement: (state) => {
      state.value -= 1
    },
    incrementByAmount: (state, action: PayloadAction<number>) => {
      state.value += action.payload
    },
    showAddCustomer: (state, action: PayloadAction<boolean>) => {
      state.isShowAdd = action.payload;
    },
    addContact: (state) => {
      state.customerAdd.arrayContact.push(1);
    }
  },
})

export const { increment, decrement, incrementByAmount, showAddCustomer, addContact } = counterSlice.actions

export default counterSlice.reducer